export * from './routes';
export * from './student.component';
export * from './student-detail/student-detail.component';
